/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
	type BaseResponse,
	BaseResponseFromJSON,
	BaseResponseToJSON,
} from '../models/BaseResponse';
import {
	type GetCalculationCommandResult,
	GetCalculationCommandResultFromJSON,
	GetCalculationCommandResultToJSON,
} from '../models/GetCalculationCommandResult';

export interface ApiV1CalculationGetRequest {
	caseId: string;
}

/**
 *
 */
export class CalculationApi extends runtime.BaseAPI {
	/**
	 * Creates request options for apiV1CalculationGet without sending the request
	 */
	async apiV1CalculationGetRequestOpts(
		requestParameters: ApiV1CalculationGetRequest
	): Promise<runtime.RequestOpts> {
		if (requestParameters['caseId'] == null) {
			throw new runtime.RequiredError(
				'caseId',
				'Required parameter "caseId" was null or undefined when calling apiV1CalculationGet().'
			);
		}

		const queryParameters: any = {};

		if (requestParameters['caseId'] != null) {
			queryParameters['caseId'] = requestParameters['caseId'];
		}

		const headerParameters: runtime.HTTPHeaders = {};

		if (this.configuration && this.configuration.accessToken) {
			// oauth required
			headerParameters['Authorization'] = await this.configuration.accessToken('Bearer', []);
		}

		let urlPath = `/api/v1/calculation`;

		return {
			path: urlPath,
			method: 'GET',
			headers: headerParameters,
			query: queryParameters,
		};
	}

	/**
	 */
	async apiV1CalculationGetRaw(
		requestParameters: ApiV1CalculationGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<runtime.ApiResponse<GetCalculationCommandResult>> {
		const requestOptions = await this.apiV1CalculationGetRequestOpts(requestParameters);
		const response = await this.request(requestOptions, initOverrides);

		return new runtime.JSONApiResponse(response, (jsonValue) =>
			GetCalculationCommandResultFromJSON(jsonValue)
		);
	}

	/**
	 */
	async apiV1CalculationGet(
		requestParameters: ApiV1CalculationGetRequest,
		initOverrides?: RequestInit | runtime.InitOverrideFunction
	): Promise<GetCalculationCommandResult> {
		const response = await this.apiV1CalculationGetRaw(requestParameters, initOverrides);
		return await response.value();
	}
}
